import { msg } from 'gt-react';
import { TruckIcon } from '@phosphor-icons/react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import {
  Route as pathlessAuthenticatedRoute,
  requireModules,
  requirePermission,
} from '../../route';

const FreightOptionsPage = lazyRouteComponent(
  () => import('./FreightOptionsPage'),
  'FreightOptionsPage',
);

/** Per-branch freight options: carriers, freight terms and carrier accounts. */
export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/procurement/freight-options',
  staticData: {
    app: {
      nav: {
        label: msg('Freight options', {
          context: 'sidebar nav label, Procurement section',
        }),
        icon: <TruckIcon className="h-4 w-4" weight="fill" />,
        group: 'Procurement',
        order: 45,
        groupOrder: 30,
      },
      access: {
        modulesAnyOf: [ProductModule.PROCUREMENT],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.FreightOption },
        ],
      },
    },
  },
  component: FreightOptionsPage,
  loader: () => ({
    crumb: msg('Freight options', { context: 'page breadcrumb' }),
  }),
  beforeLoad: async ({ context }) => {
    requireModules({ context, oneOf: [ProductModule.PROCUREMENT] });
    await requirePermission({
      context,
      action: Action.Read,
      subject: Subject.FreightOption,
    });
  },
});
